
import React, { Fragment, useState, useEffect, useReducer } from "react";
import OwlCarousel from 'react-owl-carousel';
import { apiData } from "../../../../actions";
import { useSelector } from "react-redux";

const initialState = {
  loading: true,
  data: null,
  error: false
}

const reducer = (state, action) => {
  switch (action.type) {
    case "SUCCESS":
      return {
        loading: false,
        data: action.payload,
        error: false
      };

    case "ERROR":
      return {
        loading: false,
        data: null,
        error: true
      };

    default:
      return state;
  }
}

function Comedy() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const place = useSelector(state => state.place);
  const [loader, setLoader] = useState(false);
  // const [getComedyData, setComedyData] = useState([]);
  const settings = {
    items: 4,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 4
      }
    }
  };

  const GetComedy = async () => {
    // setLoader(true);
    let payload = {
      city: place,
    };
    let apiRes = await apiData.getComedy(payload);
    dispatch({ type: "SUCCESS", payload: apiRes?.data?.comedy?.businesses })
    // setLoader(false);
  };
  useEffect(() => {
    GetComedy();

  }, [place])
  const getUserEmail = () => {
          try {
            const rawUser = localStorage.getItem('userEmail');
            const user = JSON.parse(rawUser); 
            return user?.email || '';
          } catch (error) {
            // Handle plain string fallback
            // console.error('Failed to parse userEmail from localStorage:', error);
            const rawUser = localStorage.getItem('userEmail');
            if (rawUser && typeof rawUser === 'string' && rawUser.includes('@')) {
              return rawUser; 
            }
            return ''; 
          }
        };

        const userEmail = getUserEmail();
        const handleClicks = () => {
          handleSubmit();
        };
        const [formData, setFormData] = useState({
            email: '',
            city: '',
            travelerType: '',
          });

        const handleSubmit = async () => {
          const email = userEmail 
          if (!email) {
            console.log('Please log in to continue.');
            return;
          }
          const {city, travelerType } = formData;
          
          
              const finalCity = place || city;
          // Construct the URL dynamically
          const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(email.split('@')[0])}&city=${encodeURIComponent(finalCity)}&travelerType=${encodeURIComponent(travelerType)}`;
        
          try {
            const response = await fetch(url, {
              method: 'GET',
            });
        
            if (response.ok) {
              const data = await response.json();
              console.log(data.message); 
              // setFormData({ email: '', city: '', travelerType: '' });
              // setSpecificModal(false);
            } else {
              const error = await response.json();
              console.log(error.message || 'Submission failed'); 
            }
          } catch (error) {
            console.log(error.message || 'Failed to submit form');
          }
        };
  

  return (
    <Fragment>
      {!loader ?
        <div className="flight-sec exitment-sec tour-slider new3">

          <div className="slider-sec">
            <h3>Comedy</h3>
            {state?.data && state.data.length > 0 ? (
              <OwlCarousel {...settings}>
                {state.data.map((ele, index) => (
                  <a key={index} href={ele?.url} onClick={handleClicks}>
                    <div  className="slider-main local todocomedyMain">
                      <div className="slider-block">
                        <img loading="lazy" src={ele?.image_url} alt="_image" />
                        <div className="slider-content">
                          <h3>{ele?.name.length >= 18 ? `${ele.name.slice(0, 18)}...` : ele?.name}</h3>
                          <p>{ele.location?.display_address[0]}</p>
                          <p>{ele.location?.display_address[1]}</p>
                          <p>{ele.location?.phone}</p>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </OwlCarousel>
            ) : (
              <div>
                {`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`}
              </div>
            )}
          </div>
        </div>
        : ""
      }
    </Fragment>
  );
}

export default Comedy;
